import { render } from "./MobileChartCriteria.vue?vue&type=template&id=5546c164&scoped=true"
import script from "./MobileChartCriteria.vue?vue&type=script&lang=js"
export * from "./MobileChartCriteria.vue?vue&type=script&lang=js"

import "./MobileChartCriteria.vue?vue&type=style&index=0&id=5546c164&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5546c164"]])

export default __exports__